<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      processing: false
    }
  },
  methods: {
    handleAutocompleteChange(v) {
      if (v.length > 0) {
        return v[0].id
      }

      return null
    },
    handleSubmit(e) {
      e.preventDefault()

      this.form.validateFields((err, formData) => {
        if (!err) {
          const self = this

          this.$confirm({
            title: 'Do you want to process this action?',
            content: 'Please recheck before submit',
            onOk() {
              self.processing = true
              formData.amount = formData.amount.replace(/\./g, '')
              self.$http.post(self.routeUri('hyperion.finances.deposit.store'), formData)
                .then((response) => self.handleSuccessResponse(response.data))
                .catch((error) => self.handleErrorResponse(error.response.data))
                .finally(() => {})
            },
            onCancel() {},
          })
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Saved!",
        description: "Data has been successfully saved!.",
        onClose: () => window.location.reload()
      })
    },
    handleErrorResponse(data) {
      this.processing = false
      let resMessage = 'Failed to validate data'
      let resDesc = 'We are unable to validate your request.'

      if (data.rc == '2001') {
        data = data.data
        this.form.setFields(_.mapValues(data, function (item, key) {
          return {
            errors: item.map(function (val) {
              return {
                field: key,
                message: val
              }
            })
          }
        }))
        this.form.setFields({password: {value: null}})
      } else {
        resMessage = 'Deposit Failed'
        resDesc = data.message
      }

      this.$notification.error({
        message: resMessage,
        description: resDesc
      })
    },
    formatMoney(value) {
      this.form.setFieldsValue({amount: value.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")})
    },
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form :form="form" >
      <a-divider dashed orientation="left">Bank Information</a-divider>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Bank">
        <bank-autocomplete
          v-decorator="[ 'bank_id', { rules: [ { required: true } ], getValueFromEvent: (v) => this.handleAutocompleteChange(v) }]"/>
      </a-form-item>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12}" label="Type">
        <a-radio-group v-decorator="[ 'type', { rules: [ { required: true } ]}]">
          <a-radio value="deposit">Deposit</a-radio>
          <!-- <a-radio value="loan">Loan</a-radio> -->
          <a-radio value="withdraw">Withdrawal</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-divider dashed orientation="left">Sender Information</a-divider>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Client">
        <client-autocomplete
          v-decorator="[ 'client_id', { rules: [ { required: true } ], getValueFromEvent: (v) => this.handleAutocompleteChange(v) }]"/>
      </a-form-item>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Bank">
        <a-input placeholder="Sender Bank" v-decorator="['sender_bank', { rules: [ { required: true } ] } ]">
          <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Name">
        <a-input placeholder="Sender Name" v-decorator="['sender_name', { rules: [ { required: true } ] } ]">
          <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Account">
        <a-input placeholder="Sender Account" v-decorator="['sender_account', { rules: [ { required: true } ] } ]">
          <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
        </a-input>
      </a-form-item>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Amount">
        <a-input placeholder="Amount" v-decorator="['amount', { rules: [ { required: true } ] } ]" @keyup.stop.native="formatMoney($event.target.value)">
          <a-icon slot="prefix" type="dollar" style="color: rgba(0,0,0,0.25)"/>
        </a-input>
      </a-form-item>

      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Ref #">
        <a-input placeholder="Reference Number" v-decorator="['ref_number', { rules: [ { required: true } ] } ]">
          <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 12 }" label="Auto Approve">
        <a-switch v-decorator="['auto_approve', { valuePropName: 'checked' }]"/>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 24, offset: 6}">
        <a-button type="primary" icon="save" :loading="processing" :disabled="processing" @click="handleSubmit">Save</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
